import { getFormatRoles } from "../../../utils/formatData";
import { Search } from "../../../models/home/Search.model";
import { Isearch } from "../../../schemas/Search/Search.schema";
import { states } from "../../../utils/states";
import { dayjs } from "../../../utils/Date/DateUtil";
import { IUserDetails } from "../../../schemas/user";

export const getSearchInputes = (
  searchdata: Isearch,
  userDetails: IUserDetails,
  page = 0,
  sortColumn = "pickUpStartDate",
  sortDirection = "asc"
): Search => {
  const model: Search = new Search();
  if (searchdata) {
    const userRole = getFormatRoles();
    model.originCity = searchdata.origin;
    model.originState =
      searchdata.origin === "Anywhere" ? "Anywhere" : searchdata.originState && searchdata.originState.trim();
    model.originRadius = searchdata.originRadius;
    model.originCountry = searchdata.originCountry;
    model.originPostalCode = searchdata.origin === "Anywhere" ? '' : searchdata.originPostalCode;    
    model.pickUpStartDate = searchdata.origin === "Anywhere" ? '' : searchdata.pickUpStartDate;
    model.pickUpEndDate = searchdata.origin === "Anywhere" ? '' : searchdata.pickUpEndDate;
    model.dropStartDate = searchdata.destination === "Anywhere" ? '' : searchdata.dropStartDate;
    model.dropEndDate = searchdata.destination === "Anywhere" ? '' : searchdata.dropEndDate;
    model.destinationCity = searchdata.destination;
    model.destinationStates = searchdata.destinationStates;
    model.destinationCountry = searchdata.destinationCountry;
    model.destinationPostalCode = searchdata.destination === "Anywhere" ? '' : searchdata.destinationPostalCode;
    model.destinationRadius = searchdata.destinationRadius;
    model.favorite = searchdata.favorite;
    model.trailerType = searchdata.TrailerType;
    model.userId = (userDetails?.memberDetailsResponse?.member?.upn) || "";
    model.carrierId = (userDetails?.memberDetailsResponse?.member?.carrierId) || null;
    model.page = page;
    model.size = 25;
    model.sortColumn = sortColumn;
    model.sortDirection = sortDirection;
    model.carrierScac = (userDetails?.memberDetailsResponse?.carrierInfo?.carrierScac) || "";
    model.carrierTier = (userDetails?.memberDetailsResponse?.carrierInfo?.carrierTier) || "";
    model.managedEquipmentCapability = (userDetails?.memberDetailsResponse?.carrierInfo?.managedEquipmentCapability) || "";
    model.nonManagedEquipmentCapability = (userDetails?.memberDetailsResponse?.carrierInfo?.nonManagedEquipmentCapability) || "";
    model.userRole = userRole.join(",");
  }
  return model;
};
export const getDateRange = (from: string, to: string) => {
  let fromDate = (from && from.split("T")[0]) || null;
  fromDate = fromDate ? dayjs(fromDate).format("MMM DD") : "";
  let toDate = (to && to.split("T")[0]) || null;
  toDate = toDate ? dayjs(toDate).format("MMM DD") : "";
  if (fromDate && toDate) {
    return fromDate + " - " + toDate;
  } else if (fromDate) {
    return fromDate;
  } else if (toDate) {
    return toDate;
  }
};

export const formatStatesList = (items: any) => {
	return items.map((value: any) => {
		const state = states.find((state: any) => state.code === value);
		return (state && state.name) || value;
	});
}

export const getDestinationStateValue = (detail: any) =>{
  let states = [];
  if(detail.destinationState) states.push(detail.destinationState.trim());
  if(detail.destinationState1) states.push(detail.destinationState1.trim());
  if(detail.destinationState2) states.push(detail.destinationState2.trim());
  if(detail.destinationState3) states.push(detail.destinationState3.trim());
  return states;
}
